// extracted by mini-css-extract-plugin
export var content = "_q6-1";
export var fullScreen = "_q6-0";